import { ROUTES } from "../../constants/routes";
import { Component, OnInit } from "@angular/core";
import { swalClose } from '../../utils/swals.utils';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DocService } from "src/app/services/doc/doc.service";
import { minimizeSidebar, maximizeSidebar } from "src/app/utils/sidebar.utils";
import { NotificationService } from '../../services/notification/notification.service';
import { ProjectsService } from '../../services/projects/projects.service';
import { ChildrenItems } from "../../interfaces/router-info";

const misc: any = {
  sidebar_mini_active: true,
};

@Component({
  selector: "app-sidebar",
  templateUrl: "./sidebar.component.html",
  styleUrls: ["./sidebar.component.css"],
})
export class SidebarComponent implements OnInit {

  public isCollapsed = true;
  public menuItems: Array<any>;
  public lenguageSelected: string;

  /**
   * @constructor
   * @param {NotificationService} _notificacion
   * @param {NgbModal} _modal
   */
  constructor(
    private _notificacion: NotificationService,
    private _modal: NgbModal,
    private _docService: DocService,
    private _project: ProjectsService
  ) { }

  /**
   * On Init
   * @returns {void}
   */
  ngOnInit(): void {
    this.menuItems = ROUTES.filter((menuItem) => menuItem);
  }

  /**
   * Indicates whether the network contains a TEC P33 that isn't set as the master device.
   * @returns {boolean}
   */
  public get hasNonMasterTECP33(): boolean {
    return this._project.getSelectedProject.network.some(({ nombre, isMaster }) => nombre === 'TEC P33' && !isMaster);
  }

  /**
   * Submenu paths that are locked while there's a TEC P33 that isn't the network's master.
   */
  private readonly LockedChildPaths: Array<string> = ['devices-admin', 'operation-logic'];

  /**
   * Top-level menu item paths (type: 'link') that are locked while there's a TEC P33 that isn't
   * the network's master.
   */
  private readonly LockedMenuLinks: Array<string> = ['/transfer'];

  /**
   * Indicates whether the given submenu item (Devices Admin, Operation Logic) should be locked
   * while there's a TEC P33 that isn't the network's master.
   * @param {ChildrenItems} child_item - Submenu item
   * @returns {boolean}
   */
  public isChildDisabled(child_item: ChildrenItems): boolean {
    return this.LockedChildPaths.includes(child_item.path) && this.hasNonMasterTECP33;
  }

  /**
   * Handles a click on a submenu item: if it's locked, warns the user and skips navigation;
   * otherwise closes pop-ups as usual.
   * @param {ChildrenItems} child_item - Submenu item
   * @returns {void}
   */
  public onChildItemClick(child_item: ChildrenItems): void {
    if (this.isChildDisabled(child_item)) {
      this._notificacion.showNotification('Network_Config.ERRORS.TEC-P33-MUST-BE-MASTER', 'danger', 'ui-1_simple-remove');
      return;
    }
    this.closePopUpWindows();
  }

  /**
   * Indicates whether the given top-level menu item (e.g. "Transfer") should be locked while
   * there's a TEC P33 that isn't the network's master.
   * @param {any} menu_item - Menu item
   * @returns {boolean}
   */
  public isMenuItemDisabled(menu_item: any): boolean {
    return menu_item.type === 'link' && this.LockedMenuLinks.includes(menu_item.path) && this.hasNonMasterTECP33;
  }

  /**
   * Handles a click on a top-level menu item: if it's locked, warns the user and skips
   * navigation; otherwise closes pop-ups as usual.
   * @param {any} menu_item - Menu item
   * @returns {void}
   */
  public onMenuItemClick(menu_item: any): void {
    if (this.isMenuItemDisabled(menu_item)) {
      this._notificacion.showNotification('Network_Config.ERRORS.TEC-P33-MUST-BE-MASTER', 'danger', 'ui-1_simple-remove');
      return;
    }
    this.closePopUpWindows();
  }

  /**
   * Minimize the sidebar
   * @returns {void}
   */
  public minimizeSidebar(): void {
    minimizeSidebar();
  }

  /**
   * Maximize the sidebar
   * @returns {void}
   */
  public maximizeSidebar(): void {
    maximizeSidebar();
  }

  /**
   * Displays the submenu for items that require it.
   * @param {any} event
   * @param {any} menuitem
   * @returns {void}
   */
  public myFunc(event: any, menuitem?: any): void {
    event.preventDefault();
    event.stopPropagation();
    this.sleep(10);
    if (menuitem && menuitem?.isCollapsing === undefined) {
      menuitem.isCollapsing = true;
      let element = event.target;
      while (
        element.getAttribute("data-toggle") != "collapse" &&
        element != document.getElementsByTagName("html")[0]
      ) {
        element = element.parentNode;
      }
      element = element.parentNode.children[1];
      if (
        element.classList.contains("collapse") &&
        !element.classList.contains("show")
      ) {
        element.classList = "before-collapsing";
        let style = element.scrollHeight;
        element.classList = "collapsing";
        setTimeout(() => {
          element.setAttribute("style", "height:" + style + "px");
        }, 1);
        setTimeout(() => {
          element.classList = "collapse show";
          element.removeAttribute("style");
          menuitem.isCollapsing = undefined;
        }, 350);
      } else {
        let style = element.scrollHeight;
        setTimeout(() => {
          element.setAttribute("style", "height:" + (style + 20) + "px");
        }, 3);
        setTimeout(() => {
          element.classList = "collapsing";
        }, 3);
        setTimeout(() => {
          element.removeAttribute("style");
        }, 20);
        setTimeout(() => {
          element.classList = "collapse";
          menuitem.isCollapsing = undefined;
        }, 400);
      }
    }
  }

  /**
   * Sleep
   * @param milliseconds
   * @return {void}
   */
  public sleep(milliseconds: number): void {
    const start = new Date().getTime();
    for (let i = 0; i < 1e7; i++) {
      if (new Date().getTime() - start > milliseconds) {
        break;
      }
    }
  }

  /**
   * Logout
   * @todo Funcionalidad
   * @return {void}
   */
  public logout(): void {
    console.log('Cerrar Sesión');
  }

  /**
   * Close Pop Up Windows
   * @returns {void}
   */
  public closePopUpWindows(): void {
    this._modal.dismissAll();
    swalClose();
  }

  /**
   * Show User Manual Not Available Notification
   * @returns {void}
   */
  public getUserManual(): void {
    this._notificacion.showNotification('Temporary.USER_MANUAL_NOT_AVAILABLE', 'danger', 'ui-1_bell-53');
  }

  /**
   * Handle External Action
   * @param child - Child Item
   */
  public handleExternalAction(child: ChildrenItems): void {
    const isDownloader: boolean = [ 'USER_MANUAL', 'PLUGIN_GUIDE', 'BLOCK_GUIDE', 'PLUGIN' ].includes(child.title);
    if (isDownloader) {
      this.downloadFile(child.link);
    } else {
      this.openExternalUrl(child.link);
    }
  }

  /**
   * Open External URL
   * @param {string} url - URL
   */
  private openExternalUrl(url: string): void {
    window.open(url, '_blank', 'noopener,noreferrer');
  }

  /**
   * Open Download
   * @param {string} fileName - File Name
   */
  private downloadFile(fileName: string): void {
    this._docService.downloadFile(fileName);
  }
}
